<template>
    <div class="guess-wrap">        
        <div class="guessContent">
            <h1 class="guessLarge">一、活动说明</h1>
            <p class="guessSmall guess_30h">
                猜涨跌是以上证指数(SH:000001)涨跌方向为竞猜标的金融游戏，以大盘走势为基础，通过游戏方式引导用户体验证券市场、强化投资者风险教育，进而提升投资者对证券市场的全面认识，帮助王者财经用户更好的把控市场，提高对证券市场的认知。
            </p>
            <h1 class="guessLarge guess_40h">二、竞猜规则</h1>
            <h2 class="guessMiddle guess_30h">1.参与方式</h2>
            <p class="guessSmall">
                用户需在规定的时间内预测当日上证指数是涨还是跌，并押注金币份额，即可参与竞猜。当日所有竞猜者的押注份额全部进入奖金池。
            </p>
            <h2 class="guessMiddle guess_50h">2.输赢判断标准</h2>
            <p class="guessSmall">
                竞猜标的为当期上证指数，竞猜分为看涨和看跌两种。用户在竞猜时间内，投入金币即可参与竞猜上证指数涨跌方向。交易日收盘时上证指数的涨或者跌是判断竞猜正确与否的唯一依据，当T日收盘指数&gt;T-1日收盘指数时，则判断为T日的上证指数为涨，反之则为跌，相等时为平。
            </p>
            <h2 class="guessMiddle guess_50h">3.猜对有何奖励？</h2>
            <p class="guessSmall">
                体验交易、体验炒股！同时，只要猜中当日上证指数涨跌，即可获得王者财经专属金币！金币是王者财经为用户提供的虚拟资产，是财富、身份的象征，并且与用户等级密切关联，更可在王者财经商城中兑换话费、流量、专车券、优惠卡以及未来更多的神秘大礼！
            </p>
            <h2 class="guessMiddle guess_50h">4．盈亏计算及收益分配</h2>
            <p class="guessSmall">
                竞猜正确的用户将会依据其竞猜金币的比例分配失败用户的竞猜金币。如果上证指数收平盘，则双方各自收回竞猜金币。竞猜收益分配的最小单位为1金币，按照用户实际收益从高到低依次按照1金币分配，分完为止。
            </p>
            <h2 class="guessMiddle guess_50h">5.每日竞猜时间</h2>
            <p class="guessSmall">
                猜大盘仅在交易日开启，前一交易日10:00至当日9:15竞猜当日上证指数涨跌，如果当日不是交易日则延至下一交易日，当日9：15后不再接受下注。即T-1日10：00—T日9：15，用户可以竞猜T日上证指数涨跌方向（休市日竞猜休市日后第一个交易日）。每一交易日为一个竞猜周期。T日收盘后公布结果，将在收盘后将用户赢得的金币发放到账户中(特殊情况除外)。
            </p>
            <h1 class="guessLarge guess_40h">三、排名细则</h1>
            <h2 class="guessMiddle guess_50h">1.金币收益榜：</h2>
            <p class="guessSmall">
                1）总榜：个人参加押涨跌游戏的总收益金币排行，总排行榜的概念，不区分时间段、不分用户等级，纯粹计算获胜收益金币综合的排行榜，取前100名展示，并且可以分享；<br>
                2）本月榜：规则同总榜，但计算的是本自然月的总收益金币排行情况，每自然月第一天收益数据未计算出来时，将存在没有对应排行数据的可能；<br>
                3）本周榜：规则同总榜，但计算的是本自然周的总收益金币排行情况，每自然周第一天收益数据未计算出来时，同样会存在没有对应排行数据的可能；
            </p>
            <h2 class="guessMiddle guess_50h">2.战绩榜：</h2>
            <p class="guessSmall">
                个人连胜战绩最高的排名。只有参加过竞猜的用户才能进行排名，因此赛期内未竞猜的用户将不会参加排名。而且中途竞猜一旦中断，就不是连续获胜。
            </p>
            <h2 class="guessMiddle guess_50h">3.对于个人战绩相同的用户：</h2>
            <p class="guessSmall">
                1）竞猜次数多的排名靠前；<br>
                2）战绩、竞猜次数均相同时，则首次参加竞猜日期早的靠前；<br>
                3）战绩、竞猜次数、首次参加竞猜日期均相同时，则最新参与日期早的靠前；<br>
                4）战绩、竞猜次数、首次参加竞猜日期、最新参与日期均相同时，则最新参与日期当天竞猜下注时间早的排名靠前。
            </p>
            <h2 class="guess_40h"></h2>
            <h3 class="guessBottom">备注：上述规则最终解释权归王者财经。</h3>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            back(){
                history.back()
            }
        },
    }
</script>